export const Marquee = ({ items }) => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-sand bg-linen-deep/70 py-5" aria-hidden="true">
    <div className="flex w-max animate-marquee items-center gap-10">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-10 whitespace-nowrap">
          <span className="font-serif text-lg italic text-forest/75 sm:text-xl">{item}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-terracotta" />
        </span>
      ))}
    </div>
  </div>
);
